import React from 'react';
import { motion } from 'framer-motion';
const RATHER_SAILING_SVG = 'https://cdn.magicpatterns.com/uploads/cbRmV78AWqNHmt3jUL9cbd/RatherSailing.svg';
export function AtmosphereStrip() {
  return <section className="relative w-full h-[70vh] overflow-hidden" data-id="element-61" data-mp="3g7qec02wveit">
      <div className="absolute inset-0" data-id="element-62" data-mp="3g4ufm9j8oltb">
        <img src="https://cdn.magicpatterns.com/uploads/2iGFN2sHZ72jzpWMpYnUu2/16-9-fullframe-export_(0;01;44;15)_detI.jpg" alt="Paluba plachetnice při západu slunce" className="w-full h-full object-cover" data-id="element-63" data-mp="3b7ugkikt4jbp" />
        <div className="absolute inset-0 bg-gradient-to-b from-navy-deep/40 via-navy-deep/35 to-navy-deep/60" data-id="element-64" data-mp="3l47anhk9kz6z" />
      </div>

      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 1.2
    }} className="relative z-10 h-full flex flex-col items-center justify-center px-6" data-id="element-65" data-mp="3tyvgb8tr4iwb">
        <img src={RATHER_SAILING_SVG} alt="I'd rather be sailing" className="block drop-shadow-2xl h-16 sm:h-20 md:h-28 lg:h-36 w-auto" style={{
        filter: 'brightness(0) invert(1)'
      }} data-id="element-66" data-mp="yl4ohq94x9s0" />
      </motion.div>
    </section>;
}